import { useQuery } from 'react-query'
import { UserEditModalForm } from './UserEditModalForm'


const UserEditModalFormWrapper = () => {
  return <UserEditModalForm />
}

export { UserEditModalFormWrapper }
